(function () {
  'use strict';

  var MQ = '(max-width: 1000px)';

  function initHeaderBurger(root) {
    var toggle = root.querySelector('.header-burger__toggle');
    var panel = root.querySelector('.header-burger__panel');

    if (!toggle || !panel) {
      return;
    }

    function isMobileNav() {
      return window.matchMedia(MQ).matches;
    }

    function isDesktopBurger() {
      return root.classList.contains('header-burger--desktop-rebalancer');
    }

    function canOpen() {
      // Header burgers only open below 1000px; the rebalancer hero burger
      // is desktop-only and should open at wider viewports.
      return isDesktopBurger() ? !isMobileNav() : isMobileNav();
    }

    function setOpen(open) {
      var shouldOpen = open && canOpen();

      root.classList.toggle('is-open', shouldOpen);
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      panel.hidden = !shouldOpen;
    }

    toggle.addEventListener('click', function () {
      if (!canOpen()) {
        return;
      }

      setOpen(!root.classList.contains('is-open'));
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.classList.contains('is-open')) {
        return;
      }

      if (!root.contains(event.target)) {
        setOpen(false);
      }
    });

    window.matchMedia(MQ).addEventListener('change', function () {
      setOpen(false);
    });

    setOpen(false);
  }

  function initNavDropdown(root) {
    var toggle = root.querySelector('.nav-subs__toggle');
    var panel = root.querySelector('.nav-subs__panel');

    if (!toggle || !panel) {
      return;
    }

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      setOpen(!root.classList.contains('is-open'));
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.classList.contains('is-open')) {
        return;
      }

      if (!root.contains(event.target)) {
        setOpen(false);
      }
    });

    window.matchMedia(MQ).addEventListener('change', function () {
      setOpen(false);
    });

    setOpen(false);
  }

  document.querySelectorAll('[data-header-burger]').forEach(initHeaderBurger);
  document.querySelectorAll('[data-nav-dropdown]').forEach(initNavDropdown);
})();
